module.exports = __webpack_public_path__ + "static/img/tab3.4b43cee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/challenge/tab3.png
// module id = 4hMe
// module chunks = 1